export default __webpack_public_path__ + "static/media/4_Багшийн_мэргэжил_дээшлүүлэх_зардал.dc1b0948.pptx";